import { LISTAR_TIPOCITAS } from "../../types";

// eslint-disable-next-line import/no-anonymous-default-export
export default (state, action) => {
  switch (action.type) {
    case LISTAR_TIPOCITAS:
      return {
        ...state,
        tipoCitas: action.payload,
      };

    default:
      return state;
  }
};
